import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=1abd2a2c"
import script from "./FooterSection.vue?vue&type=script&scoped=true&lang=js"
export * from "./FooterSection.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=1abd2a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports